import pick from 'lodash/pick';
import type { TicketType, TicketTypeResponseEntity } from '../../../../../common/types';
import type { TicketTypesResource } from '../../../types';

const repsonseEntityToTicketType = (entity: TicketTypeResponseEntity): TicketType =>
	pick(entity, ['id', 'name', 'iconUrl', 'description']);

export const toTicketTypesMap = (
	entities: TicketTypeResponseEntity[],
): TicketTypesResource['data'] =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	entities.reduce<Record<string, any>>(
		(acc, entity) => ({
			// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
			...acc,
			[entity.id]: repsonseEntityToTicketType(entity),
		}),
		{},
	);
